<script setup lang="ts">
import { faUser } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

defineOptions({
  name: 'UserMenuAvatar',
})
</script>

<template>
  <div class="user-avatar">
    <div class="user-avatar__icon">
      <FontAwesomeIcon :icon="faUser" />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Auth/UserMenuAvatar.scss" />
